import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
// import AccountCircle from '@material-ui/icons/AccountCircle';
// import Lock from '@material-ui/icons/Lock';
import ExitToApp from '@material-ui/icons/ExitToApp';

import CurrentUser from '~/contexts/CurrentUser';
import Storage from '~/providers/Storage';
import { profile, changePassword } from '~/config/routes';
import { URL } from '~/config/uri';

import Item from '../Item';
import useStyles from './styles';

function User({ history, open }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { user, setUser } = useContext(CurrentUser);
  const [openLogoff, setOpenLogoff] = useState(false);
  const [expand, setExpand] = useState(
    !!profile.match(history.location.pathname) ||
      !!changePassword.match(history.location.pathname)
  );

  function handleClick() {
    setExpand(!expand);
  }

  function handleLogoffOpen() {
    setOpenLogoff(true);
  }

  function handleLogoffClose() {
    setOpenLogoff(false);
  }

  async function logoff() {
    setUser(null);
    await Storage.removeItem(Storage.tokenKey);
    await Storage.removeItem(Storage.refreshTokenKey);
    await Storage.removeItem(Storage.userKey);
    await Storage.removeItem(Storage.countryId);

    history.replace('/');
  }

  return (
    <>
      <ListItem
        button
        classes={{
          root: classes.root,
        }}
        onClick={handleClick}
      >
        <ListItemIcon>
          <img
            src={`${URL}/public/user_face/${user.uuid}.jpg?size=140`}
            className={classes.image}
          />
        </ListItemIcon>

        <ListItemText
          primary={user.name}
          classes={{
            primary: classes.text,
            root: classes.userNameRoot,
          }}
        />

        {expand ? (
          <ExpandLess className={classes.icon} />
        ) : (
          <ExpandMore className={classes.icon} />
        )}
      </ListItem>

      <Collapse in={expand} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {/* <Item
            open={open}
            item={{
              route: profile,
              text: profile.title,
              Icon: AccountCircle,
            }}
          /> */}

          {/* <Item
            open={open}
            item={{
              route: changePassword,
              text: changePassword.title,
              Icon: Lock,
            }}
          /> */}

          <Item
            open={open}
            item={{
              text: t('menu-user-logoff'),
              Icon: ExitToApp,
              onClick: handleLogoffOpen,
            }}
          />
        </List>
      </Collapse>

      <Dialog open={openLogoff} onClose={handleLogoffClose}>
        <DialogTitle>{t('logoff-title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('logoff-descrition')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus color="primary" onClick={handleLogoffClose}>
            {t('logoff-cancel')}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              handleLogoffClose();
              logoff();
            }}
          >
            {t('logoff-confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

User.propTypes = {
  open: PropTypes.bool.isRequired,
};

export default withRouter(React.memo(User));
